export interface AnalyticsConfig {
  enabled: boolean;
  debug: boolean;
  engagementIntervalMs: number;
  cookieExpiryDays: number;
}

// You can also use custom environment variables
const enableAnalytics = process.env.REACT_APP_ENABLE_ANALYTICS === "true";
const enableAnalyticsDebug = process.env.REACT_APP_ENABLE_ANALYTICS_DEBUG === "true";

export const analyticsConfig: AnalyticsConfig = {
  // Enable analytics only in production
  enabled: enableAnalytics,

  // Enable debug logging (set to true to see logs in development)
  debug: enableAnalyticsDebug,

  // Track engagement every 30 seconds
  engagementIntervalMs: 30000,

  // Cookie expiry in days (2 years)
  cookieExpiryDays: 730,
};

// Helper function to check if analytics should run
export const shouldTrackAnalytics = (): boolean => {
  return analyticsConfig.enabled;
};
